import React, { useEffect, useRef } from "react";
import Searchbar from "../Searchbar";
import { AnimatePresence, motion } from "motion/react";
import MobileNavItems from "./MobileNavItems";

const initialY = '-110%';

const slideDown = {
	initial: {
		y: initialY, 
	},
	animate: {
		y: 0,
		opacity: 1,
		transition: {
			ease: 'easeOut',
		},
	},
	exit: {
		y: initialY,
		transition: {
			ease: 'easeIn',

		}
	}
}

const MobileMenu = ({ isOpen, menu, externalLinks, labels }) => {
	const { donate, store, tickets } = externalLinks;
	const languageSelector = useRef(null);
	
	useEffect(() => { 
		const weglotInline = document.querySelector('.weglot-inline');

		if (!weglotInline || !languageSelector.current) return;

		languageSelector.current.replaceChildren(weglotInline.cloneNode(true));
		
	}, [isOpen])

	return (
		<AnimatePresence>
			{isOpen && (
				<motion.div {...slideDown} className="mobile-nav header__nav">
					<div className="mobile-nav__toolbar">
						<Searchbar />
						<div className="mobile-nav__lang" ref={languageSelector}></div>
					</div>

					<MobileNavItems menu={menu} labels={labels} />

					<div className="mobile-nav__button-container">
						<a href={tickets} aria-label={labels.goToTicketsPage} className="header__button--tickets wp-block-button__link">{labels.tickets}</a>
						<a href={donate} aria-label={labels.goToDonationPage} className="header__button--donate wp-block-button__link">{labels.donate}</a>
						<a href={store} aria-label={labels.goToStore} className="nested-menu__button--store wp-block-button__link">{labels.store}</a>
					</div>
				</motion.div>
			)}
		</AnimatePresence>
	);
};

export default MobileMenu;
